/*
 * @Author: yang_yang 1663724228@qq.com
 * @Date: 2023-03-20 09:23:27
 * @LastEditors: yang_yang 1663724228@qq.com
 * @LastEditTime: 2023-04-10 09:23:48
 * @FilePath: \jyh5\src\assets\i18n\zh\commApp\monthlyHealthReport.js
 * @Description: 健康月报
 */
const month = {
    health_report: "健康报告",
    day: "天",
    month: "月",
    year: "年",
    years: "年度",
    years_health_report: "年度健康报告",
    time: "时间",
    times: "次",
    km: "公里",
    hour: "小时",
    minute: "分钟",
    circle: "圈",
    step: "步",
    w_step: "万步",
    score: "分",
    now_month: "本月",
    last_month: "上月",
    keep_measure: "坚持监测身体状况和适当的运动，",
    can_keep_health: "可以帮助您更好的维持自身健康！",
    overview: "总体概览",
    initiative_measure: "主动测量次数",
    comm: "正常",
    percent: "占比",
    overPercent: "正常比例超过",
    users: "的用户",
    allDistance: "运动总里程",
    allDistance2: "运动总距离",
    average_sleep: "平均睡眠时长",
    average_sleep2: "平均睡眠",
    measure_statistics: "测量情况统计",
    now_month_measure: "本月检测",
    comm_times: "正常占比次数",
    compare_last_month: "比上月",
    heart_rate: "心率",
    electrocardiograph: "心电",
    blood_pressure: "血压",
    sp: "收缩压",
    dp: "舒张压",
    spo: "血氧",
    pressure: "压力",
    lowest: "最低",
    highest: "最高",
    high: "偏高",
    high2: "高",
    low: "偏低",
    low2: "低",
    light: "轻微",
    middle: "中",
    max_continuous_heart_rate: "最高连续检测心率",
    sleep_statistics: "睡眠情况统计",
    sport_statistics: "运动统计",
    outdoor_run: "户外跑步",
    indoor_run: "室内跑步",
    walk: "健走",
    swim: "游泳",
    free_training: "自由训练",
    sportNum: "运动总次数",
    sportTimes: "运动总时长",
    month_average_step: "本月日均步数",
    share_now: "立即分享",
    average_day_sleep: "日均深睡",
    average_day_light_sleep: "日均浅睡眠",
    average_day_REM: "日均REM",
    average_day_wake: "日均清醒",
    no_data: "暂无数据",

    // 年报
    start: "开启",
    more_health_body: "你坚守更健康的自己",
    initiative_measure_num: "主动测量次数",
    after_being_busy: "忙碌之余，",
    remember_measure: "还记得要坚持测量喔！",
    medical_treatment_statistics: "医疗检测次数统计",
    measurement_analysis: "测量分析",
    comm_num: "正常次数",
    blood_pressure_comm_num: "血压正常次数",
    keep_measure_blood_pressure:
        "规范、持续测量血压是预防和治疗血压类疾病的必要做法",
    spo_comm_num: "血氧正常次数",
    comm_precent: "正常占比数",
    low_bp: "低血压",
    high_bp: "重度血压升高",
    low_spo: "低血氧",
    insufficient_spo: "供氧不足",
    know_spo: "了解血氧可以反应身体供氧情况",
    light_pressure_num: "轻微压力次数",
    high_pressure_num: "高压力",
    suitable_pressure: "适当的压力可以提高人的潜能和效率",
    night_sleep: "夜晚合理的睡眠结构，",
    daytime_vitality: "可以让您白天元气满满～",
    full_sleep: "睡眠充足，超过",
    sleep_analyse: "睡眠情况分析",
    amount_run: "相当于跑了",
    marathon: "个马拉松",
    now_year_walk: "本年度总步数",
    amount_around_earth: "相当于绕地球走了",
    year_distance: "全年运动距离",
    year_measure: "全年测量",
    index_comm_precent: "健康指标测量正常比例统计",

    month_list: [
        "1月",
        "2月",
        "3月",
        "4月",
        "5月",
        "6月",
        "7月",
        "8月",
        "9月",
        "10月",
        "11月",
        "12月",
    ],
    更新日期: "更新日期",
    生效日期: "生效日期",
    版本记录: "版本记录",
    确定: "确定",
    隐私协议: "隐私协议",
    服务条款: "服务条款",
    ECGAI隐私协议: "CoDoctor ECG-AI 隐私协议",
    ECGAI服务条款: "CoDoctor ECG-AI 服务条款",
};
export { month };



// WEBPACK FOOTER //
// ./src/assets/i18n/zh/commApp/monthlyHealthReport.js